<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show" :title="$t('Auction Settings')" @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')" :is-loading="loading"
                   scrollable size="lg" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="featured" type="checkbox"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="after_sale_end_date" type="datepicker"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="after_sale_end_time" type="timepicker"
                        :rules="model.after_sale_end_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="clearance_start_date" type="datepicker"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="clearance_start_time" type="timepicker"
                        :rules="model.clearance_start_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="clearance_end_date" type="datepicker"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="clearance_end_time" type="timepicker"
                        :rules="model.clearance_end_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="strict_end_date" type="datepicker"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="strict_end_time" type="timepicker"
                        :rules="model.strict_end_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="clearance_comment" type="textarea"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="view_by_appointment" type="select2" :items="viewByAppointmentOptions"
                        display-field="${item.text}" value-field="key"/>
        </div>
      </div>
      <div class="row" v-if="showViewDates">
        <div class="col-md-6">
          <input-widget :model="model" attribute="viewing_start_date" type="datepicker"
                        :rules="showViewDates ? 'required' : ''"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="viewing_start_time" type="timepicker"
                        :rules="model.viewing_start_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row" v-if="showViewDates">
        <div class="col-md-6">
          <input-widget :model="model" attribute="viewing_end_date" type="datepicker"
                        :rules="showViewDates ? 'required' : ''"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="viewing_end_time" type="timepicker"
                        :rules="model.viewing_end_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row" v-if="showViewDates">
        <div class="col-md-6">
          <input-widget :model="model" attribute="private_viewing_start_date" type="datepicker"
                        rules=""/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="private_viewing_start_time" type="timepicker"
                        :rules="model.private_viewing_start_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row" v-if="showViewDates">
        <div class="col-md-6">
          <input-widget :model="model" attribute="private_viewing_end_date" type="datepicker"
                        :rules="model.private_viewing_start_date ? 'required' : ''"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="private_viewing_end_time" type="timepicker"
                        :rules="model.private_viewing_end_date ? 'required' : ''"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="viewing_comment" type="textarea"/>
        </div>
      </div>
      <div class="row" v-if="isLive">
        <div class="col-md-6">
          <input-widget :model="model" attribute="telephone_bid_request_cut_off" type="number" step="1"
          :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>

        <div class="col-md-6">
          <input-widget :model="model" attribute="commission_bid_request_cut_off" type="number" step="1"
          :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>
      </div>
      <div class="row" v-if="isLive">
        <div class="col-md-6">
          <input-widget :model="model" attribute="bidder_registration_cut_off" type="number" step="1"
          :append-question="$t('If left empty, corresponding action buttons on the front-end will always remain visible If 0 minutes is entered, corresponding action buttons will disappear exactly at auction start time.')"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="has_delay" type="checkbox" @change="clearLotDelaySettings"/>
        </div>
      </div>
      <div class="row" v-if="model.has_delay">
        <div class="col-md-6">
          <input-widget :model="model" :appendQuestion="LOT_END_DATE_EXTENSION_HINT" attribute="lot_delay_seconds" type="select2" :items="lotDelaySecondsOptions"
                        display-field="${item.key}" value-field="value"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" :appendQuestion="NUMBER_OF_LOTS_TO_EXTEND_HINT" attribute="lot_delay_batch_size" type="number"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" :appendQuestion="BUY_NOW_CUT_OFF_TIME_HINT" attribute="buy_now_cut_off_days" type="select2" :items="buyNowCutOffDaysOptions"
                        display-field="${item.key}" value-field="value"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" :appendQuestion="BIDDING_EXTENSION_HINT" attribute="bidding_extension" type="select2"
                        :items="biddingExtensionOptions" display-field="${item.key}" value-field="value"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="max_total_delay" type="select2" :items="maxTotalDelayOptions"
                        display-field="${item.key}" value-field="value"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <input-widget :model="model" attribute="tax_required" type="checkbox" @change="clearSaleTaxesSettings"/>
        </div>
      </div>
      <div class="row" v-if="model.tax_required">
        <div class="col-md-6">
          <input-widget :model="model" attribute="hammer_tax_rate" type="number"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="bp_tax_rate" type="number"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import SaleModel from "@/modules/sales/Sale.model";
  import {
    LOT_END_DATE_EXTENSION_HINT,
    NUMBER_OF_LOTS_TO_EXTEND_HINT,
    BUY_NOW_CUT_OFF_TIME_HINT,
    BIDDING_EXTENSION_HINT
  } from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('sales');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "AuctionSettingsModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new SaleModel(),
        LOT_END_DATE_EXTENSION_HINT: LOT_END_DATE_EXTENSION_HINT,
        NUMBER_OF_LOTS_TO_EXTEND_HINT: NUMBER_OF_LOTS_TO_EXTEND_HINT,
        BUY_NOW_CUT_OFF_TIME_HINT: BUY_NOW_CUT_OFF_TIME_HINT,
        BIDDING_EXTENSION_HINT: BIDDING_EXTENSION_HINT,
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.auctionSettingsData.modal,
        viewByAppointmentOptions: state => state.viewByAppointmentOptions,
        editObject: state => state.view.auctionSettingsData.modal.object,
      }),
      ...mapStateGlobal({
        lotDelaySecondsOptions: state => state.lotDelaySecondsOptions,
        buyNowCutOffDaysOptions: state => state.buyNowCutOffDaysOptions,
        biddingExtensionOptions: state => state.biddingExtensionOptions,
        maxTotalDelayOptions: state => state.maxTotalDelayOptions,
        auctionSettingsDefaultValues: state => state.auctionSettingsDefaultValues
      }),
      defaultLotDelaySeconds() {
        return this.auctionSettingsDefaultValues.lot_delay_seconds;
      },
      defaultLotDelayBatchSize() {
        return this.auctionSettingsDefaultValues.lot_delay_batch_size;
      },
      showViewDates() {
        return this.model.view_by_appointment === 'no' || this.model.view_by_appointment === 'yes_with_dates'
      },
      isLive() {
        return this.model && this.model.type === 'live'
      },
    },
    methods: {
      ...mapActions(['hideAuctionSettingsModal', 'updateSaleSettings']),
      async onSubmit() {
        this.loading = true;
        const processedData = this.model.toJSON()
        let cut_off_elements = {}
        if (this.isLive){
          cut_off_elements['telephone_bid_request_cut_off'] = processedData.telephone_bid_request_cut_off;
          cut_off_elements['commission_bid_request_cut_off'] = processedData.commission_bid_request_cut_off;
          cut_off_elements['bidder_registration_cut_off'] = processedData.bidder_registration_cut_off;
        };
        let response = await this.updateSaleSettings({
          featured: processedData.featured,
          after_sale_end_date: processedData.after_sale_end_date,
          clearance_start_date: processedData.clearance_start_date,
          clearance_end_date: processedData.clearance_end_date,
          strict_end_date: processedData.strict_end_date,
          clearance_comment: processedData.clearance_comment,
          view_by_appointment: processedData.view_by_appointment,
          viewing_start_date: processedData.viewing_start_date,
          viewing_end_date: processedData.viewing_end_date,
          private_viewing_start_date: processedData.private_viewing_start_date,
          private_viewing_end_date: processedData.private_viewing_end_date,
          viewing_comment: processedData.viewing_comment,
          ...cut_off_elements,
          has_delay: processedData.has_delay,
          lot_delay_seconds: processedData.lot_delay_seconds,
          lot_delay_batch_size: processedData.lot_delay_batch_size,
          buy_now_cut_off_days: processedData.buy_now_cut_off_days,
          bidding_extension: processedData.bidding_extension,
          max_total_delay: processedData.max_total_delay,
          tax_required: processedData.tax_required,
          hammer_tax_rate: processedData.hammer_tax_rate,
          bp_tax_rate: processedData.bp_tax_rate,
        });

        if (response.success) {
          this.loading = false;
          this.hideAuctionSettingsModal();
          this.$toast('success', this.$t('Settings were successfully updated'));
        } else {
          this.loading = false;
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onHidden() {
        this.hideAuctionSettingsModal();
      },
      clearLotDelaySettings(has_delay) {
        if (!has_delay) {
          this.model.lot_delay_batch_size = null;
          this.model.lot_delay_seconds = null;
        }
      },
      clearSaleTaxesSettings(tax_required) {
        if (!tax_required) {
          this.model.hammer_tax_rate = null;
          this.model.bp_tax_rate = null;
        }
      }
    },
    watch: {
      editObject() {
        if (this.model.tax_required) {
          this.editObject.hammer_tax_rate = this.editObject.hammer_tax_rate ? this.editObject.hammer_tax_rate : 0;
          this.editObject.bp_tax_rate = this.editObject.bp_tax_rate ? this.editObject.bp_tax_rate : 0;
        }
        this.model = new SaleModel(this.editObject)
      },
      'model.view_by_appointment': {
        deep: true,
        handler() {
          if (!this.model.view_by_appointment || !this.showViewDates) {
            this.model.viewing_end_date = null;
            this.model.viewing_start_date = null;
            this.model.viewing_end_time = null;
            this.model.viewing_start_time = null;
            this.model.private_viewing_end_date = null;
            this.model.private_viewing_start_date = null;
            this.model.private_viewing_end_time = null;
            this.model.private_viewing_start_time = null;
          }
        }
      },
      'model.has_delay': {
        handler() {
          if (this.model.has_delay) {
            this.model.lot_delay_seconds = this.model.lot_delay_seconds ? this.model.lot_delay_seconds : this.defaultLotDelaySeconds.value;
            this.model.lot_delay_batch_size = this.model.lot_delay_batch_size ? this.model.lot_delay_batch_size : this.defaultLotDelayBatchSize;
          }
        }
      },
      'model.tax_required': {
        handler() {
          if (this.model.tax_required) {
            this.model.hammer_tax_rate = this.model.hammer_tax_rate ? this.model.hammer_tax_rate : 0;
            this.model.bp_tax_rate = this.model.bp_tax_rate ? this.model.bp_tax_rate : 0;
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>

